export default __webpack_public_path__ + "static/media/thumbnail.8aae40f9.jpg";